import { render, staticRenderFns } from "./ConfirmDeleteComponent.vue?vue&type=template&id=6d6fa3cd"
import script from "./ConfirmDeleteComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports